/* eslint-disable no-console */

import { register } from "register-service-worker"
import { Notification } from "element-ui"
// import router from "./router"

if (process.env.NODE_ENV === "production") {
  // 暂不用消息通知的方式控制页面
  // if ("serviceWorker" in navigator) {
  //   navigator.serviceWorker.addEventListener("message", function({ data }) {
  //     if (!data) return
  //     switch (data.code) {
  //       case "10000":
  //         console.log(data)
  //         router.goto({ name: "upgrade" })
  //         break
  //     }
  //   })
  // }
  register(`${process.env.BASE_URL}sw.js`, {
    ready() {
      console.log("App is being served from cache by a service worker~")
    },
    registered() {
      console.log("Service worker has been registered~")
    },
    cached() {
      console.log("Content has been cached for offline use.")
    },
    updatefound() {
      console.log("New content is downloading.")
    },
    updated() {
      Notification.info({
        title: "检测到网页内容更新",
        message: "点击此消息以应用更新",
        duration: 0,
        position: "bottom-right",
        onClick: function() {
          location.reload()
        }
      })
      console.log("New content is available; please refresh.")
    },
    offline() {
      console.log("No internet connection found. App is running in offline mode.")
    },
    error(error) {
      console.error("Error during service worker registration:", error)
    }
  })
}
